module.exports = __webpack_public_path__ + "static/img/lun_1.1f7e514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_1.jpg
// module id = Dd9D
// module chunks = 1